import { SVG, SVGProps } from './svg'

export function IconToolRectRotated(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M16 7c0 .4 0 .7-.3 1l8.3 8.3a2 2 0 11.2 3.6l-4.4 4.3A2 2 0 0118 27a2 2 0 01-1.7-3L8 15.7a2 2 0 11-.2-3.6l4.4-4.3A2 2 0 0114 5a2 2 0 012 2zm7.4 12.2a2 2 0 01-.1-2.3l-8.2-8.2a2 2 0 01-2.3-.1l-4.2 4.2a2 2 0 01.1 2.3l8.2 8.2a2 2 0 012.3.1l4.2-4.2zM14 8a1 1 0 100-2 1 1 0 000 2zm-6 6a1 1 0 11-2 0 1 1 0 012 0zm10 12a1 1 0 100-2 1 1 0 000 2zm8-8a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </SVG>
  )
}
